<template>
  <div class="yy">
    <!-- 上盒子 -->
    <div class="yy-box1">
      <ul>
        <li><router-link to="/honor/myzs1">企业简介</router-link></li>
        <li><router-link to="/honor/myzs2">企业文化</router-link></li>
        <li><router-link to="/honor/myzs3">组织架构</router-link></li>
        <li><router-link to="/honor/myzs4">企业资质</router-link></li>
        <li><router-link to="/honor/myzs7">企业体系认证</router-link></li>
        <li><router-link to="/honor/myzs8">企业信用认证</router-link></li>
        <li><router-link to="/honor/myzs5">荣誉证书</router-link></li>
        <!-- <li><router-link to="/honor/myzs6">新闻动态</router-link></li> -->
      </ul>
    </div>

    <!-- 下盒子：一行三列，图片+文字 -->
    <div class="qyzz">
      <div class="cert-item">
        <!-- <img
          src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-45-12-923%E9%83%91%E5%B7%9E%E7%BF%BC%E5%8D%9A%E9%A4%90%E9%A5%AE%E4%BC%81%E4%B8%9A%E7%AE%A1%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8.jpg"
          alt="营业执照"
        /> -->
        <el-image
                  src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-08-24-15-21-03-861%E9%83%91%E5%B7%9E%E7%BF%BC%E5%8D%9A%E9%A4%90%E9%A5%AE%E4%BC%81%E4%B8%9A%E7%AE%A1%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%20-%20%E6%89%93%E7%A0%81.jpg"
                  class="image-placeholder"
                  fit="cover"
                  :preview-src-list="['https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-08-24-15-21-03-861%E9%83%91%E5%B7%9E%E7%BF%BC%E5%8D%9A%E9%A4%90%E9%A5%AE%E4%BC%81%E4%B8%9A%E7%AE%A1%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%20-%20%E6%89%93%E7%A0%81.jpg']"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <!-- <div v-else class="no-image">
                  <i class="el-icon-picture-outline"></i>
                </div> -->
        <div class="cert-title">营业执照</div>
      </div>
      <div class="cert-item">
        <!-- <img
          src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-45-44-212%E7%BF%BC%E5%8D%9A%E9%A4%90%E9%A5%AE%E9%A3%9F%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%E5%89%AF%E6%9C%AC.jpg"
          alt="食品经营许可证"
        /> -->
        <el-image
                  src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-08-24-15-22-20-989%E7%BF%BC%E5%8D%9A%E9%A4%90%E9%A5%AE%E9%A3%9F%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%28%E6%89%93%E7%A0%81%29.jpg"
                  class="image-placeholder"
                  fit="cover"
                  :preview-src-list="['https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-08-24-15-22-20-989%E7%BF%BC%E5%8D%9A%E9%A4%90%E9%A5%AE%E9%A3%9F%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%28%E6%89%93%E7%A0%81%29.jpg']"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
        <div class="cert-title">食品经营许可证</div>
      </div>
      <!-- <div class="cert-item">
        <img src="@/assets/ryzs/6.jpg" alt="荣誉证书" />
        <div class="cert-title">授权证书</div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.image-placeholder {
  max-height:520px;
}

/* 三列布局 */
.qyzz {
  width: 80%;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.cert-item {
  flex: 1;
  min-width: 200px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  text-align: center;
}

.cert-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
}
.cert-item:hover .cert-title {
  color:#b81212;
}

.cert-item img {
  width: 100%;
  height: 240px;
  object-fit: contain;
  background-color: #f5f5f5;
  padding: 12px;
}

.cert-title {
  padding: 12px 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  border-top: 1px solid #eee;
  background: #fafafa;
}

/* 响应式 */
@media (max-width: 768px) {
  .qyzz {
    width: 95%;
    flex-direction: column;
    align-items: center;
  }
  .cert-item {
    width: 100%;
    max-width: 320px;
  }
}
</style>